import React from "react";
import "./GamePreloader.scss";

const GamePreloader = () => {
  return (
    <div className="casino-category-types casino-category-types-full">
      <div className="casino-category-games ">
        <div className="casino-game-item skeleton-loader-game-cube" />
        <div className="casino-game-item skeleton-loader-game-cube" />
        <div className="casino-game-item skeleton-loader-game-cube" />
        <div className="casino-game-item skeleton-loader-game-cube" />
        <div className="casino-game-item skeleton-loader-game-cube" />
        <div className="casino-game-item skeleton-loader-game-cube" />
        <div className="casino-game-item skeleton-loader-game-cube" />
        <div className="casino-game-item skeleton-loader-game-cube" />
        <div className="casino-game-item skeleton-loader-game-cube" />
        <div className="casino-game-item skeleton-loader-game-cube" />
        <div className="casino-game-item skeleton-loader-game-cube" />
        <div className="casino-game-item skeleton-loader-game-cube" />
        <div className="casino-game-item skeleton-loader-game-cube" />
        <div className="casino-game-item skeleton-loader-game-cube" />
        <div className="casino-game-item skeleton-loader-game-cube" />
      </div>
    </div>
  );
};

export { GamePreloader };
